import { render, staticRenderFns } from "./AcceptAccount.vue?vue&type=template&id=2a6a528e&scoped=true&lang=html&"
import script from "./AcceptAccount.vue?vue&type=script&lang=js&"
export * from "./AcceptAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6a528e",
  null
  
)

export default component.exports